<template>
    <div class="tabs">
        <ul class="tabs__selectors">
            <li
                v-for="(tab, index) in tabs"
                :key="index"
                :class="['tabs__heading', {'tabs__heading--active' : index === selectedIndex}]"
                @click="selectTab(index)"
            >
                {{ tab.title }}
            </li>
        </ul>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'AppTabs',
        data() {
            return {
                selectedIndex: 0,
                tabs: [],
            }
        },
        created() {
            this.tabs = this.$children;
        },
        mounted() {
            this.selectTab(0)
        },
        methods: {
            selectTab(i) {
                this.selectedIndex = i;

                // loop over all the tabs
                this.tabs.forEach((tab, index) => {
                    tab.isActive = (index === i)
                })
            }
        }
    }
</script>

<style lang="scss">

</style>